import { z } from 'zod'
import { ProcessOrderPaymentRequestSchema } from '~/services/api/generated'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

const normalize = fieldNormalizer({ always: { numericString: ['payment_method_id'] } })

export const PaymentRetryPayment = (_context: NoContext) =>
  z.preprocess(normalize, ProcessOrderPaymentRequestSchema)
